import { render } from "./UserReferenceProgress.vue?vue&type=template&id=39f9ae28&ts=true"
import script from "./UserReferenceProgress.vue?vue&type=script&lang=ts"
export * from "./UserReferenceProgress.vue?vue&type=script&lang=ts"

import "./UserReferenceProgress.vue?vue&type=style&index=0&id=39f9ae28&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__